/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  DEFAULT_PAGE_SIZE,
  FOOD_PUBLIC_TYPE,
  ITINERARY_FOOD_INVOICE_BILLING_STATUS,
} from '../../../../config/constants';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import Table from '../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import EnumStatus from '../../../common/EnumStatus';

const getDefaultPageSize = (list = []) =>
  list.length > 10 ? DEFAULT_PAGE_SIZE : list.length || 1;

const ItinerarySupplierFoodReportDetail = ({
  registeredBus,
  originLocationName,
  destinationLocationName,
  departureDate,
  itinerarySupplierFoodDetailList,
  driverList,
  cabinCrewList,
  passengerFlowForItinerary,
  actualPassengerFlowForItinerary,
  ticketPostponeQuantity,
}) => {
  const passengerFlowForLocationList =
    passengerFlowForItinerary &&
    passengerFlowForItinerary.passengerFlowForLocationList
      ? passengerFlowForItinerary.passengerFlowForLocationList
      : [];

  const actualPassengerFlowForLocationList =
    actualPassengerFlowForItinerary &&
    actualPassengerFlowForItinerary.passengerFlowForLocationList
      ? actualPassengerFlowForItinerary.passengerFlowForLocationList
      : [];

  return (
    <>
      <ResourceProperty label="Origen:">
        {originLocationName || '-'}
      </ResourceProperty>

      <ResourceProperty label="Destino:">
        {destinationLocationName || '-'}
      </ResourceProperty>

      <ResourceProperty label="Bus:">
        {registeredBus && registeredBus.companyBusId
          ? registeredBus.companyBusId
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Cantidad de Boletos Postergados:">
        {ticketPostponeQuantity || '-'}
      </ResourceProperty>

      <ResourceProperty label="Fecha de salida:">
        {departureDate
          ? tzNormalizeDate({
              date: departureDate,
              format: DATE_TIME_FORMAT,
            })
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Parada actual:">
        {actualPassengerFlowForItinerary &&
        actualPassengerFlowForItinerary.currentBoardingLocationName
          ? actualPassengerFlowForItinerary.currentBoardingLocationName
          : '-'}
      </ResourceProperty>

      <h3>Detalle de alimentación</h3>

      {itinerarySupplierFoodDetailList &&
      itinerarySupplierFoodDetailList.length > 0 ? (
        <Table
          columns={[
            {
              Header: 'Alimentación',
              accessor: 'food.name',
              className: 'text-center',
            },
            {
              Header: 'Tipo público',
              accessor: 'publicType',
              className: 'text-center',
              Cell: (row) => (
                <EnumStatus
                  enumObject={FOOD_PUBLIC_TYPE}
                  enumValue={row.value}
                />
              ),
            },
            {
              Header: 'Cantidad',
              accessor: 'quantity',
              className: 'text-center',
            },
            {
              Header: 'Costo',
              accessor: 'cost',
              className: 'text-center',
            },
            {
              Header: 'Estado de Facturación',
              accessor: 'billingStatus',
              className: 'text-center',
              Cell: (row) => (
                <EnumStatus
                  enumObject={ITINERARY_FOOD_INVOICE_BILLING_STATUS}
                  enumValue={row.value}
                />
              ),
            },
          ]}
          data={itinerarySupplierFoodDetailList}
          filterable
          manual={false}
          defaultFilterMethod={filterMethodCaseInsensitive}
          defaultPageSize={getDefaultPageSize(itinerarySupplierFoodDetailList)}
          showPagination={itinerarySupplierFoodDetailList.length > 10}
        />
      ) : (
        <div className="alert alert-info">Sin detalle de alimentación</div>
      )}

      <h3>Conductores</h3>

      {driverList && driverList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'driverName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'driverIdDocumentNumber',
                className: 'text-center',
              },
              {
                Header: 'Tipo',
                accessor: 'driverType.name',
                className: 'text-center',
              },
            ]}
            data={driverList}
            defaultPageSize={getDefaultPageSize(driverList)}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin conductores</div>
      )}

      <h3>Servicio a bordo</h3>

      {cabinCrewList && cabinCrewList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'cabinCrewName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'cabinCrewIdDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={cabinCrewList}
            defaultPageSize={getDefaultPageSize(cabinCrewList)}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin Servicio a bordo</div>
      )}

      <h3>Flujo de pasajeros inicial</h3>

      {passengerFlowForLocationList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Parada autorizada',
                accessor: 'locationName',
                className: 'text-center',
              },
              {
                Header: 'Embarques',
                accessor: 'boardingPassengers',
                className: 'text-center',
              },
              {
                Header: 'Desembarques',
                accessor: 'leavingPassengers',
                className: 'text-center',
              },
            ]}
            data={passengerFlowForLocationList}
            defaultPageSize={getDefaultPageSize(passengerFlowForLocationList)}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin flujo programado</div>
      )}

      <h3>Flujo de pasajeros actual</h3>

      {actualPassengerFlowForLocationList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Parada autorizada',
                accessor: 'locationName',
                className: 'text-center',
              },
              {
                Header: 'Embarques',
                accessor: 'boardingPassengers',
                className: 'text-center',
              },
              {
                Header: 'Desembarques',
                accessor: 'leavingPassengers',
                className: 'text-center',
              },
            ]}
            data={actualPassengerFlowForLocationList}
            defaultPageSize={getDefaultPageSize(
              actualPassengerFlowForLocationList,
            )}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin flujo actual</div>
      )}
    </>
  );
};

ItinerarySupplierFoodReportDetail.propTypes = {
  registeredBus: PropTypes.shape({
    id: PropTypes.number,
    companyBusId: PropTypes.string,
  }),
  originLocationName: PropTypes.string,
  destinationLocationName: PropTypes.string,
  departureDate: PropTypes.number,
  itinerarySupplierFoodDetailList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      itinerarySupplierFoodId: PropTypes.number,
      foodId: PropTypes.number,
      food: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        description: PropTypes.string,
      }),
      quantity: PropTypes.number,
      cost: PropTypes.number,
    }),
  ),
  driverList: PropTypes.arrayOf(
    PropTypes.shape({
      driverId: PropTypes.number,
      driverName: PropTypes.string,
      driverIdDocumentNumber: PropTypes.string,
      driverType: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        description: PropTypes.string,
      }),
    }),
  ),
  cabinCrewList: PropTypes.arrayOf(
    PropTypes.shape({
      cabinCrewId: PropTypes.number,
      cabinCrewName: PropTypes.string,
      cabinCrewIdDocumentNumber: PropTypes.string,
    }),
  ),
  passengerFlowForItinerary: PropTypes.shape({
    itineraryId: PropTypes.number,
    passengerFlowForLocationList: PropTypes.array,
    currentBoardingLocationId: PropTypes.number,
    currentBoardingLocationName: PropTypes.string,
  }),
  actualPassengerFlowForItinerary: PropTypes.shape({
    itineraryId: PropTypes.number,
    passengerFlowForLocationList: PropTypes.array,
    currentBoardingLocationId: PropTypes.number,
    currentBoardingLocationName: PropTypes.string,
  }),
  ticketPostponeQuantity: PropTypes.number,
};

ItinerarySupplierFoodReportDetail.defaultProps = {
  registeredBus: null,
  originLocationName: null,
  destinationLocationName: null,
  departureDate: null,
  itinerarySupplierFoodDetailList: [],
  driverList: [],
  cabinCrewList: [],
  passengerFlowForItinerary: null,
  actualPassengerFlowForItinerary: null,
  ticketPostponeQuantity: null,
};

export default ItinerarySupplierFoodReportDetail;
